class Facets extends HTMLElement {
  constructor() {
    super();

    this.form = document.querySelector('.js-facets-form');

    if(this.form) {
      this.productGrid = document.querySelector('.js-product-grid-content') || null;

      this.form.addEventListener('input', this.debounce((event) => {
        this.handleFormChange(event);
      }, 300));

      this.minRange = document.querySelector(".js-min-price-range");
      this.maxRange = document.querySelector(".js-max-price-range");
      this.track = document.querySelector(".js-slider-track");
      this.minInput = document.querySelector(".js-price-min");
      this.maxInput = document.querySelector(".js-price-max");

      if(this.track) {
        this.minRange.addEventListener("input", () => this.updateSliderTrack());
        this.maxRange.addEventListener("input", () => this.updateSliderTrack());

        this.minInput.addEventListener("input", () => this.updateSliderFromInput());
        this.maxInput.addEventListener("input", () => this.updateSliderFromInput());

        this.updateSliderTrack();
      }

      document.querySelectorAll('.js-remove-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleRemoveFilter(event));
      });

      document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(element => {
        element.addEventListener('change', (event) => this.handleInputChange(event));
      });

      document.querySelectorAll('.js-change-sort-by-value').forEach(element => {
        element.addEventListener('click', (event) => this.handleSortBy(event));
      });

      document.querySelectorAll('.js-toggle-filter').forEach(element => {
        element.addEventListener('click', (event) => this.handleToggleFilter(event));
      });

      document.querySelectorAll('.js-toggle-facets-item').forEach(element => {
        element.addEventListener('click', (event) => this.handleToggleFacetsItem(event));
      });
    }
  }

  handleFormChange() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    const activeSortElement = document.querySelector('.js-change-sort-by-value.active');
    if (activeSortElement) {
      const sortValue = activeSortElement.getAttribute('data-value');
      if (sortValue) {
        searchParams.set('sort_by', sortValue);
      }
    }

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());

    this.toggleLoadingClass('add');
  }

  handleSortBy(event) {
    event.preventDefault();
    const sortValue = event.currentTarget.getAttribute('data-value');
    if (!sortValue) return;
    
    let searchParams;

    if(this.form) {
      const formData = new FormData(this.form);
      searchParams = new URLSearchParams(formData);
    } else {
      searchParams = new URLSearchParams();
    }
    searchParams.set('sort_by', sortValue);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll('.js-change-sort-by-value').forEach(el => el.classList.remove('active'));
    event.currentTarget.classList.add('active');
    
    const currentSortDisplay = document.querySelector('.js-current-sort-by');
    if (currentSortDisplay) {
      currentSortDisplay.textContent = event.currentTarget.textContent;
    }

    this.classList.add('loading');
  }

  handleToggleFilter(event) {
    event.preventDefault();
    document.querySelectorAll('.js-facets-container').forEach(element => {
      if (element.classList.contains("active")) {
        element.classList.add("deactivate");
        setTimeout(() => {
          element.classList.remove("active", "display");
          document.body.style.overflow = 'visible';
        }, 300);
      } else {
        element.classList.add("display");
        element.classList.remove("deactivate");
        setTimeout(() => {
          element.classList.add("active");
        }, 10);
        document.body.style.overflow = 'hidden';
        this.initializeFacetsHeights();
      }
    });
  }

  handleToggleVerticalFilter(event) {
    event.preventDefault();
    const filtersHidden = JSON.parse(localStorage.getItem('filtersHidden')) || false;

    document.querySelectorAll('.js-vertical-filter').forEach(element => {
      element.classList.toggle("hide-desktop-filters");
    });

    document.querySelectorAll('.js-show-hide-filters').forEach(element => {
      element.classList.toggle("d-none");
    });

    localStorage.setItem('filtersHidden', JSON.stringify(!filtersHidden));
  }

  toggleLoadingClass(type) {
    if(type == 'add') {
      this.classList.add('loading');
    } else {
      this.classList.remove('loading');
    }
  }

  renderPage(searchParams) {
    const currentView = new URL(window.location.href).searchParams.get('view');
    const viewParam = currentView ? `&view=${currentView}` : '';
    const url = `${window.location.pathname}?${searchParams}${viewParam}`;

    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const productGridContent = doc.querySelector('.js-product-grid-content');
        if (productGridContent && this.productGrid) {
          this.productGrid.innerHTML = productGridContent.innerHTML;

          const offset = 120;
          const elementPosition = this.productGrid.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }

        const productsCounter = doc.querySelector('.js-products-counter');
        const productsCounterTarget = document.querySelector('.js-products-counter');
        if (productsCounter && productsCounterTarget) {
          productsCounterTarget.innerHTML = productsCounter.innerHTML;
        }

        if (typeof wrapProductsAfterBanners === 'function') wrapProductsAfterBanners();
        if (typeof initCollectionBannerCarousels === 'function') initCollectionBannerCarousels();
        if (typeof initCursorDragEffect === 'function') initCursorDragEffect();
        if (typeof initializeObservers === 'function') initializeObservers();
        if (typeof initInfiniteScroll === 'function') initInfiniteScroll();
        if (typeof productGridForm === 'function') productGridForm();

        if (typeof _swat !== 'undefined' && typeof _swat.initializeActionButtons === 'function') {
          _swat.initializeActionButtons('body');
        }

        this.toggleLoadingClass('remove');
      })
      .catch(error => {
        console.error('Error fetching filtered results:', error);
        this.toggleLoadingClass('remove');
      });
  }

  updateSliderTrack() {
    let minVal = parseInt(this.minRange.value);
    let maxVal = parseInt(this.maxRange.value);

    const minPercent = ((minVal - this.minRange.min) / (this.minRange.max - this.minRange.min)) * 100;
    const maxPercent = ((maxVal - this.maxRange.min) / (this.maxRange.max - this.maxRange.min)) * 100;

    this.track.style.left = minPercent + "%";
    this.track.style.right = (100 - maxPercent) + "%";

    this.minInput.value = minVal;
    this.maxInput.value = maxVal;
  }

  updateSliderFromInput() {
    let minVal = parseInt(this.minInput.value);
    let maxVal = parseInt(this.maxInput.value);

    if (minVal < parseInt(this.minRange.min)) minVal = parseInt(this.minRange.min);
    if (maxVal > parseInt(this.maxRange.max)) maxVal = parseInt(this.maxRange.max);
    if (minVal > maxVal) minVal = maxVal;

    this.minRange.value = minVal;
    this.maxRange.value = maxVal;

    this.updateSliderTrack();
  }

  addActiveFilter(filterParam, filterValue, filterLabel) {
    const activeFiltersContainers = document.querySelectorAll('.js-active-filters');
    if (!activeFiltersContainers.length) return;

    activeFiltersContainers.forEach(activeFiltersContainer => {
      let existingFilter = activeFiltersContainer.querySelector(`a[data-filter="${filterParam}"][data-value="${filterValue}"]`);
      if (existingFilter) return;

      const li = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = "#";
      anchor.classList.add('js-remove-filter');
      anchor.setAttribute('data-filter', filterParam);
      anchor.setAttribute('data-value', filterValue);
      anchor.innerHTML = `${filterLabel} <span>✕</span>`;

      li.appendChild(anchor);
      activeFiltersContainer.appendChild(li);

      anchor.addEventListener('click', (event) => this.handleRemoveFilter(event));
    });
  }

  handleRemoveFilter(event) {
    event.preventDefault();
    
    const filterParam = event.currentTarget.getAttribute('data-filter');
    const filterValue = event.currentTarget.getAttribute('data-value');
    
    if (!filterParam || !filterValue) return;
    
    const checkbox = document.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    
    searchParams.delete(filterParam);

    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }
    
    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(filter => filter.parentElement?.remove());

    this.toggleLoadingClass('add');
  }

  handleClearFacets(event) {
    event.preventDefault();
    
    document.querySelectorAll('.js-facets-form input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    document.querySelectorAll('.js-remove-filter').forEach(filter => {
      filter.parentElement?.remove();
    });
    
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    searchParams.delete('q');
    
    const currentView = new URL(window.location.href).searchParams.get('view');
    if (currentView) {
      searchParams.set('view', currentView);
    }

    window.history.pushState({}, '', `?${searchParams.toString()}`);
    this.renderPage(searchParams.toString());
    
    this.toggleLoadingClass('add');
  }

  handleInputChange(event) {
    const filterParam = event.target.name;
    const filterValue = event.target.value;
    const filterLabel = event.target.closest('label')?.textContent.trim() || filterValue;
    
    if (event.target.checked) {
      this.addActiveFilter(filterParam, filterValue, filterLabel);
    } else {
      document.querySelectorAll(`.js-remove-filter[data-filter="${filterParam}"][data-value="${filterValue}"]`).forEach(activeFilter => activeFilter.parentElement?.remove());
    }
  }

  initializeFacetsHeights() {
    document.querySelectorAll('.js-facets-item:not(.calculated)').forEach(item => {
      item.classList.add('calculated')
      const height = item.scrollHeight;
      item.setAttribute('data-height', height);
      item.style.height = `${height}px`;
    });
  }

  handleToggleFacetsItem(event) {
    event.preventDefault();

    const target = event.currentTarget.closest('.js-facets-item');
    if (!target) return;

    const savedHeight = target.getAttribute('data-height');

    if (target.classList.contains('active')) {
      target.classList.add('deactivate');
      target.style.height = `${savedHeight}px`;
      setTimeout(() => {
        target.classList.remove('active', 'display', 'deactivate');
      }, 300);
    } else {
      target.classList.add('display');
      target.classList.remove('deactivate');

      setTimeout(() => {
        const height = target.scrollHeight;
        target.style.height = `${height}px`; 
        target.classList.add('active');
      }, 10);
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('collection-facets', Facets);